import React from 'react'
import { MenuItem, TextField } from '@material-ui/core'
import PropTypes from 'prop-types'
import { OnChange } from 'react-final-form-listeners'
import { Form } from 'react-final-form'
import { Select, Autocomplete } from 'mui-rff'
import QuestionHeader from './questionHeader'

export default function RenderDropdown(props) {
  const { elmIndex, elm, valIndex, valueChange, allowModify } = props
  if (!elm.Value[valIndex]) elm.Value[valIndex] = ['']

  const initialValues = {}
  const name = `elm-${elmIndex}-val-${valIndex}`
  initialValues[name] = elm.Value[valIndex][0]
  const options = elm.Options?.split(',').map((val, key) => {
    if (elm.Autocomplete) return { val: val.trim() }
    return <MenuItem key={key} value={val.trim()}>{val.trim()}</MenuItem>
  }) ?? []

  if (!!initialValues[name] && elm.Autocomplete && options.every(e => e.val != initialValues[name])) {
    options.push({
      val: initialValues[name]
    })
  }

  return <div key={elmIndex}>
    <QuestionHeader helpTooltip={elm.ShowHelpTooltip ? elm.HelpTooltip : ''} prompt={elm.Prompt} allowBlanks={!!elm.AllowBlanks} />
    <Form onSubmit={() => { }}
      subscription={{}}
      initialValues={initialValues}
      //render={({ values }) => (<>
      render={() => (<>
        {elm.Autocomplete ?
          <Autocomplete name={name} variant="outlined" disabled={!allowModify}
            options={options}
            getOptionValue={option => option.val}
            getOptionLabel={option => option.val}
            renderInput={(params) => <TextField {...params} variant="outlined" onChange={(e) => { if (elm.Freeform) valueChange(elmIndex, valIndex, [e.target.value?.toString().trim()]) }} />}
            freeSolo={!!elm.Freeform}
          />
          :
          <Select name={name} variant="outlined" disabled={!allowModify}>
            {options}
          </Select>
        }
        <OnChange name={name}>
          {(newVal) => {
            if (!elm.Freeform && !options.some(e => e.val != newVal?.trim())) return
            valueChange(elmIndex, valIndex, [newVal?.trim()])
          }}
        </OnChange>
      </>)} //debug: <pre>{JSON.stringify(values, 0, 2)}</pre>
    />
  </div>
}

RenderDropdown.propTypes = {
  elmIndex: PropTypes.number.isRequired,
  elm: PropTypes.object.isRequired,
  valIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  valueChange: PropTypes.func.isRequired,
  allowModify: PropTypes.bool.isRequired,
}